import { Store } from '@ngrx/store';
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import { SelectedHypotheticalService } from 'HypotheticalsApp/services/selected-hypothetical.service';
import { HypotheticalsFolderableListItemBaseDirective } from './hypotheticals-folderable-list-item-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "FoldersApp/services/bulk-action-selection.service";
import * as i3 from "HypotheticalsApp/services/selected-hypothetical.service";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i6 from "FoldersApp/features/folders-shared/folderable/folderable.directive";
import * as i7 from "FoldersApp/features/folders-shared/folder-base/folder-base.component";
import * as i8 from "FoldersApp/features/folders-shared/folder-operations-dropdown/folder-operations-dropdown.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i12 from "../../../../../../../../sharing/static/sharing/ts/pipes/get-owner-display-name.pipe";
import * as i13 from "../../../../../../../../sharing/static/sharing/ts/pipes/get-sharing-tooltip-message.pipe";
import * as i14 from "../../../../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
function HypotheticalsOpenSavedListItemComponent_Conditional_0_ng_template_2_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵelement(2, "ycn-folder-operations-dropdown", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const folder_r1 = i0.ɵɵnextContext().folder;
    i0.ɵɵnextContext();
    const folderBase_r2 = i0.ɵɵreference(1);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r2.relativePositionedElemId)("item", folder_r1)("folderIsDisabled", folderBase_r2.isBulkSelectionDisabled)("listItemView", true)("resourceType", ctx_r2.folderable.resourceType)("resourceTypeDescription", ctx_r2.folderable.resourceTypeDescription)("ancestorFolderId", ctx_r2.ancestorInfo.id);
} }
function HypotheticalsOpenSavedListItemComponent_Conditional_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "div", 7);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵelement(4, "div", 7);
    i0.ɵɵpipe(5, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(6, HypotheticalsOpenSavedListItemComponent_Conditional_0_ng_template_2_Conditional_6_Template, 3, 7, "div", 9);
} if (rf & 2) {
    const folder_r1 = ctx.folder;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(2, 3, folder_r1.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(5, 6, folder_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.showFileDropdown ? 6 : -1);
} }
function HypotheticalsOpenSavedListItemComponent_Conditional_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-hypotheticals-open-saved-list-item", 12);
} if (rf & 2) {
    const folderable_r4 = ctx.folderable;
    const ancestorInfo_r5 = ctx.ancestorInfo;
    i0.ɵɵproperty("folderable", folderable_r4)("ancestorInfo", ancestorInfo_r5);
} }
function HypotheticalsOpenSavedListItemComponent_Conditional_0_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "span");
    i0.ɵɵtext(2, "There are no scenarios in this folder.");
    i0.ɵɵelementEnd()();
} }
function HypotheticalsOpenSavedListItemComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-base", 5, 0);
    i0.ɵɵtemplate(2, HypotheticalsOpenSavedListItemComponent_Conditional_0_ng_template_2_Template, 7, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, HypotheticalsOpenSavedListItemComponent_Conditional_0_ng_template_4_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, HypotheticalsOpenSavedListItemComponent_Conditional_0_ng_template_6_Template, 3, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const folderColumnDataFragment_r6 = i0.ɵɵreference(3);
    const listItemFragment_r7 = i0.ɵɵreference(5);
    const emptyFolderFragment_r8 = i0.ɵɵreference(7);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("folderable", ctx_r2.folderable)("ancestorInfo", ctx_r2.ancestorInfo)("folderColumnDataFragment", folderColumnDataFragment_r6)("listItemFragment", listItemFragment_r7)("emptyFolderFragment", emptyFolderFragment_r8);
} }
function HypotheticalsOpenSavedListItemComponent_Conditional_1_div_0_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵpipe(1, "getSharingTooltipMessage");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", i0.ɵɵpipeBind1(1, 4, ctx_r2.hypothetical));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-team");
} }
function HypotheticalsOpenSavedListItemComponent_Conditional_1_div_0_Conditional_20_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "ycn-simple-dropdown", 28);
    i0.ɵɵlistener("handler", function HypotheticalsOpenSavedListItemComponent_Conditional_1_div_0_Conditional_20_Template_ycn_simple_dropdown_handler_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.fileDropdownHandler($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r2.relativePositionedElemId)("inputDisabled", ctx_r2.isBulkSelectionDisabled)("tooltipTitle", "More Options")("tooltipPlacement", "bottom")("buttonClass", ctx_r2.fileDropdownButtonClass)("config", ctx_r2.fileDropdownConfig)("dropdownClass", "dropdown-menu-right dropdown-menu-with-icons")("showDropdownCaret", false);
} }
function HypotheticalsOpenSavedListItemComponent_Conditional_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16)(2, "label", 17)(3, "input", 18);
    i0.ɵɵlistener("click", function HypotheticalsOpenSavedListItemComponent_Conditional_1_div_0_Template_input_click_3_listener() { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.bulkActionSelectionService.toggleSelectedItem(ctx_r2.folderable.resourceType, ctx_r2.hypothetical.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 19);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 20)(6, "div", 21)(7, "div", 22);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 23);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 24);
    i0.ɵɵtext(10, "S");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "a", 25);
    i0.ɵɵlistener("click", function HypotheticalsOpenSavedListItemComponent_Conditional_1_div_0_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.filenameClickHandler(ctx_r2.hypothetical)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, HypotheticalsOpenSavedListItemComponent_Conditional_1_div_0_div_12_Template, 3, 6, "div", 26);
    i0.ɵɵpipe(13, "isSharedWithOthers");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 6);
    i0.ɵɵelement(15, "div", 7);
    i0.ɵɵpipe(16, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 8);
    i0.ɵɵelement(18, "div", 7);
    i0.ɵɵpipe(19, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(20, HypotheticalsOpenSavedListItemComponent_Conditional_1_div_0_Conditional_20_Template, 3, 8, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("bg-yc-blue-90", ctx_r2.isBulkSelected);
    i0.ɵɵproperty("folderable", ctx_r2.folderable)("ancestorInfo", ctx_r2.ancestorInfo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r2.isBulkSelectionDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r2.isBulkSelected);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("name", "icon-file");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r2.hypothetical.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 12, ctx_r2.hypothetical));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(16, 14, ctx_r2.hypothetical.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(19, 17, ctx_r2.hypothetical));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.showFileDropdown ? 20 : -1);
} }
function HypotheticalsOpenSavedListItemComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, HypotheticalsOpenSavedListItemComponent_Conditional_1_div_0_Template, 21, 19, "div", 14);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r2.bulkActionSelectionService.idsByResourceType$));
} }
export class HypotheticalsOpenSavedListItemComponent extends HypotheticalsFolderableListItemBaseDirective {
    constructor(store, bulkActionSelectionService, selectedFolderableService) {
        super(store);
        this.store = store;
        this.bulkActionSelectionService = bulkActionSelectionService;
        this.selectedFolderableService = selectedFolderableService;
    }
    filenameClickHandler(hypothetical) {
        this.selectedFolderableService.selectFolderable(hypothetical.id);
    }
}
HypotheticalsOpenSavedListItemComponent.ɵfac = function HypotheticalsOpenSavedListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HypotheticalsOpenSavedListItemComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.BulkActionSelectionService), i0.ɵɵdirectiveInject(i3.SelectedHypotheticalService)); };
HypotheticalsOpenSavedListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HypotheticalsOpenSavedListItemComponent, selectors: [["ycn-hypotheticals-open-saved-list-item"]], standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [["folderBase", ""], ["folderColumnDataFragment", ""], ["listItemFragment", ""], ["emptyFolderFragment", ""], ["ycn-folderable", "", 1, "tr", 3, "bg-yc-blue-90", "folderable", "ancestorInfo"], [3, "folderable", "ancestorInfo", "folderColumnDataFragment", "listItemFragment", "emptyFolderFragment"], [1, "td", "col-3"], [1, "file-td-wrap", "pt-1", "pb-1", 3, "textContent"], [1, "td", "col-3", "col-md-2"], [1, "td", "file-td-grip", "col-3", "col-lg-1"], [1, "btn-group", "pt-1", "pb-1"], [3, "id", "item", "folderIsDisabled", "listItemView", "resourceType", "resourceTypeDescription", "ancestorFolderId"], [3, "folderable", "ancestorInfo"], [1, "get-started-small", "flex-auto"], ["class", "tr", "ycn-folderable", "", 3, "bg-yc-blue-90", "folderable", "ancestorInfo", 4, "ngIf"], ["ycn-folderable", "", 1, "tr", 3, "folderable", "ancestorInfo"], [1, "td-checkbox"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", 3, "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "td", "file-td-name"], [1, "file-name", "file-td-wrap", "pt-1", "pb-1"], [1, "file-icon", "file-fc"], ["ycnIcon", "", 3, "name"], [1, "file-abbr"], ["href", "javascript:void(0)", 3, "click", "textContent"], ["class", "btn btn-xs btn-circle btn-transparent btn-share ml-1", "ycnTooltip", "", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle", 4, "ngIf"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-share", "ml-1", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"], ["ycnTooltip", "", 1, "dropdown", 3, "handler", "id", "inputDisabled", "tooltipTitle", "tooltipPlacement", "buttonClass", "config", "dropdownClass", "showDropdownCaret"]], template: function HypotheticalsOpenSavedListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, HypotheticalsOpenSavedListItemComponent_Conditional_0_Template, 8, 5)(1, HypotheticalsOpenSavedListItemComponent_Conditional_1_Template, 2, 3, "div", 4);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.folderable.resourceType === "folder" ? 0 : 1);
    } }, dependencies: [i4.NgIf, i5.DisabledDirective, i6.FolderableDirective, i7.FolderBaseComponent, i8.FolderOperationsDropdownComponent, i9.IconDirective, i10.SimpleDropdownComponent, i11.TooltipDirective, HypotheticalsOpenSavedListItemComponent, i4.AsyncPipe, i4.DatePipe, i12.GetOwnerDisplayName, i13.GetSharingTooltipMessage, i14.IsSharedWithOthersPipe], encapsulation: 2, changeDetection: 0 });
